import * as React from "react";
import { Alert, AlertTitle } from "@mui/material";
import ComponentLoader from "../../../components/common/componentLoader";
import FlexGrid from "../../../layouts/flexGrid";
import { useGetCclNotificationsByRecipientMutation } from "../../../services/cclTokenedNotificationApi";
import { eGroupIds, UserClaimsService } from "../../../services/currentUserService/currentUserService";
import { getErrorMsg } from "../../../utilities/rtkQueryErrorHelpers";
import RegistrationNotificationsDataGridPro from "../../registrations/registrationDetail/notifications/registrationNotificationsDataGridPro";
import CommonPopup from "../../../components/common/commonPopup";
import NotificationPreviewPanel from "../../notifications/notificationDetail/preview/NotificationPreviewPanel";

interface NotificationsProps {}

const Notifications: React.FC<NotificationsProps> = () => {
    const [runSearch, { data: notifications, isLoading, isError, error }] =
        useGetCclNotificationsByRecipientMutation();
    const [notificationId, setNotificationId] = React.useState<string>("");
    const [open, setOpen] = React.useState<boolean>(false);
    const [previewLoaded, setPreviewLoaded] = React.useState<boolean>(false);

    const claimsService = new UserClaimsService();
    const email = claimsService.GetCurrentUserEmail();
    const isReadOnly = claimsService.IsUserReadonlyPopupUser();
    const viewPopup = claimsService.IsUserInGroups([eGroupIds.eNWAAdmin, eGroupIds.eClientAdmin]);

    React.useEffect(() => {
        if (email !== undefined && email.length > 0) runSearch(email);
        // eslint-disable-next-line
    }, [runSearch]);

    function showErrorAlert(msg: string | undefined) {
        return (
            <Alert severity="error" sx={{ fontSize: 14 }}>
                <AlertTitle sx={{ fontSize: 14 }}>Error</AlertTitle>
                {msg}
            </Alert>
        );
    }

    if (isLoading) {
        return <ComponentLoader msg="Loading" />;
    }

    if (isError) {
        return showErrorAlert(getErrorMsg(error));
    }

    const notificationsCallback = (id: string) => {
        setNotificationId(id);
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    return (
        <>
            <FlexGrid>
                <RegistrationNotificationsDataGridPro
                    notifications={notifications}
                    isLoading={isLoading}
                    fromMyAccess={isReadOnly || viewPopup}
                    myAccessCallback={notificationsCallback}
                />
            </FlexGrid>
            {open && notificationId && (
                <CommonPopup open={open} onClose={onClose} previewLoaded={previewLoaded}>
                    <NotificationPreviewPanel
                        notificationId={notificationId}
                        forceChecked={true}
                        onPreviewLoaded={() => setPreviewLoaded(true)}
                    />
                </CommonPopup>
            )}
        </>
    );
};

export default Notifications;
